module.exports = __webpack_public_path__ + "media/icon/icon-windy-gray-c7000fc7.svg";